
import * as R from 'ramda'
import { ANALYSIS_GROUPT_TYPE_MAP } from '@Bill/constants'
import i18n from '@/locales'
import { numerify } from '@/filters'
import { BRAND_MAP } from '@/constants'
import { accountsFilterByOem } from '@/utils/utils'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  data () {
    const { group, domain_id } = this.$route.query
    const initGroup = group && ANALYSIS_GROUPT_TYPE_MAP[group] ? group : 'project'
    const initDomain = group === 'project' && domain_id ? [domain_id] : []
    return {
      formData: {
        group: [initGroup],
        platform_brand: [],
        account: [],
        linked_name: [],
        cloudprovider: [],
        region: [],
        project: [],
        domain: initDomain,
        charge_type: undefined,
        resource_type: [],
        origin_res_type: [],
        date: this.getDate(),
        spec: [],
        financial_unit: [],
        tag: {},
        instance_tag: {},
        project_tag: {},
        tag_key: {},
        tag_key1: {},
        project_tag_key: {},
        project_tag_key1: {},
        instance_tag_key: {},
        instance_tag_key1: {},
        tag_val_split: '',
        operation_num: 1,
        service_period: 1,
      },
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      OPERATION_NUM_MIN: 1,
      OPERATION_NUM_MAX: 100000000,
      SERVICE_PERIOD_MIN: 1,
      SERVICE_PERIOD_MAX: 100000000,
    }
  },
  computed: {
    dataGroupCount () {
      let groupCount = 1
      if (this.dataList[0] && this.dataList[0].data && this.dataList[0].data[0] && this.dataList[0].data[0].hasOwnProperty('name')) {
        groupCount = 2
      }
      return groupCount
    },
    tableData () {
      const columns = []
      // 第一维度列表名为标签时，使用标签key
      const nameTitle = this.formData.group[0] === 'tag' && this.tagGroupParams && this.tagGroupParams.tag_key ? this.getTagKey(this.tagGroupParams.tag_key) : ANALYSIS_GROUPT_TYPE_MAP[this.formData.group[0]].value || this.$t('bill.text_72')
      columns.push({
        field: 'name',
        minWidth: 150,
        fixed: 'left',
        resizable: true,
        title: nameTitle,
        sortable: this.formData.group.length === 1,
        sortBy: 'name',
        formatter: ({ row }) => {
          // if (this.formData.group[0] === 'tag' && this.tagGroupParams && this.tagGroupParams.tag_key) {
          //   if (!row.name || row.name === '___no_value__') {
          //     return this.$t('common_736')
          //   }
          // }
          return this.getNameI18n(row.name, this.formData.group[0])
        },
      })
      let data = []
      let all_fee = 0
      if (this.dataGroupCount > 1 && this.groupCount > 1) { // 多次聚合
        const nameTitle1 = this.formData.group[1] === 'tag' && this.tagGroupParams && this.tagGroupParams.tag_key1 ? this.getTagKey(this.tagGroupParams.tag_key1) : ANALYSIS_GROUPT_TYPE_MAP[this.formData.group[1]].value || this.$t('bill.text_72')
        columns.push({
          field: 'name2',
          minWidth: 150,
          fixed: 'left',
          resizable: true,
          title: nameTitle1,
          formatter: ({ row }) => {
            // if (this.formData.group[1] === 'tag' && this.tagGroupParams && this.tagGroupParams.tag_key1) {
            //   if (!row.name2 || row.name2 === '___no_value__') {
            //     return this.$t('common_736')
            //   }
            // }
            return this.getNameI18n(row.name2, this.formData.group[1])
          },
        })
        if (this.dataList) {
          this.dataList.map((level1Item, index1) => {
            level1Item.data.map((level2Item, index2) => {
              // 每一行
              const obj = { name: level1Item.name, name2: level2Item.name } // 未成功合并单元格的替代选项
              let all = 0
              level2Item.data.map(item => {
                if (index1 === 0 && !columns.some(col => col.field === item.date_info)) {
                  columns.push({
                    field: item.date_info,
                    title: item.date_info,
                    minWidth: 135,
                    resizable: true,
                    sortable: this.formData.group.length === 1,
                    sortBy: item.date_info,
                    formatter: ({ row }) => {
                      return row[item.date_info] ? `${this.currencySign} ${numerify(row[item.date_info], '0,0.00')}` : `${this.currencySign} 0.00`
                    },
                  })
                }
                all += item.stat_value
                // 每一行中每一个日期列
                obj[item.date_info] = item.stat_value
              })
              // 一行总计
              obj.all = all
              data.push(obj)
              all_fee += all
            })
            // 第一维度的循环完成增加第一维度的小计
            const levelData = this.groupStatValue(level1Item.data)
            const obj = { name: level1Item.name, name2: this.$t('bill.subtotal'), all: 0, rowType: 'total' }
            levelData.map(item => {
              obj[item.date_info] = item.stat_value
              obj.all += item.stat_value
            })
            data.push(obj)
          })
        }
      } else { // 单次聚合
        if (this.dataList.length) {
          data = this.dataList.map((dataItem, index) => {
            const obj = { name: dataItem.name }
            let all = 0
            dataItem.data.map(item => {
              if (index === 0) {
                columns.push({
                  field: item.date_info,
                  title: item.date_info,
                  minWidth: 135,
                  resizable: true,
                  sortable: this.formData.group.length === 1,
                  sortBy: item.date_info,
                  formatter: ({ row }) => {
                    return row[item.date_info] ? `${this.currencySign} ${numerify(row[item.date_info], '0,0.00')}` : `${this.currencySign} 0.00`
                  },
                })
              }
              all += isNaN(item.stat_value) ? 0 : item.stat_value
              obj[item.date_info] = item.stat_value
            })
            // 单行总计
            obj.all = all
            // 所有总计
            all_fee += all
            return obj
          })
        }
      }
      // 计算每行的占比
      data.forEach(item => {
        item.percent = all_fee > 0 ? (parseFloat(item.all / all_fee) * 100).toFixed(2) + '%' : '0%'
      })
      // 计算总条数
      // eslint-disable-next-line
      this.tablePage.total = data.length
      // eslint-disable-next-line
      this.tablePage.currentPage = 1

      // 添加总计和占比
      columns.push({
        field: 'all',
        title: this.$t('bill.text_316'),
        minWidth: 115,
        resizable: true,
        sortable: this.formData.group.length === 1,
        sortBy: 'all',
        align: 'center',
        fixed: 'right',
        formatter: ({ row }) => {
          return `${this.currencySign} ${numerify(row.all, '0,0.00')}`
        },
      })
      columns.push({
        field: 'percent',
        title: this.$t('bill.text_317'),
        minWidth: 115,
        resizable: true,
        sortable: this.formData.group.length === 1,
        sortBy: 'all',
        align: 'center',
        fixed: 'right',
      })
      // 按第一维度名称排序
      const sorter = R.sortBy(R.prop('name'))
      const result = sorter(data)
      return {
        columns,
        data: result,
      }
    },
    footerRow () {
      const rows = []
      // footerRow中的一行
      const totalRow = [this.$t('bill.text_316')]
      if (this.dataGroupCount > 1 && this.groupCount > 1) {
        totalRow.push(this.$t('bill.text_316'))
      }
      const { data, columns } = this.tableData
      columns.map(col => {
        const { field } = col
        if (['name', 'name2', 'percent'].indexOf(field) === -1) {
          let colTotal = 0
          data.map(item => {
            if (item.rowType !== 'total') {
              colTotal += isNaN(item[field]) ? 0 : item[field]
            }
          })
          totalRow.push(`${this.currencySign} ${numerify(colTotal, '0,0.00')}`)
        }
      })
      totalRow.push('100%')
      rows.push(totalRow)
      return rows
    },
    analysisExcelColumnMap () {
      const columnMap = {}
      this.tableData.columns.map(item => {
        const col = {
          field: item.field,
        }
        // 数据行处理
        if (['name', 'name2', 'percent'].indexOf(item.field) === -1) {
          col.callback = (value) => {
            if (!value) return `${this.currencySign} 0.00`
            const res = parseFloat(value).toFixed(2)
            return isNaN(res) ? value : `${this.currencySign} ${res}`
          }
        }
        // 名字翻译
        if (item.field === 'name') {
          col.callback = (value) => {
            // if (this.formData.group[0] === 'tag' && this.tagGroupParams && this.tagGroupParams.tag_key) {
            //   if (!value) {
            //     return this.$t('common_736')
            //   }
            // }
            return this.getNameI18n(value, this.formData.group[0])
          }
        }
        if (item.field === 'name2') {
          col.callback = (value) => {
            // if (this.formData.group[1] === 'tag' && this.tagGroupParams && this.tagGroupParams.tag_key1) {
            //   if (!value) {
            //     return this.$t('common_736')
            //   }
            // }
            return this.getNameI18n(value, this.formData.group[1])
          }
        }
        columnMap[item.title] = col
      })
      return columnMap
    },
    analysisExcelData () {
      const footerRows = []
      const { columns } = this.tableData
      if (this.tableData.columns.length) {
        this.footerRow.map((originRow, idx1) => {
          const row = {}
          columns.map((col, idx2) => {
            if (originRow[idx2]) {
              row[col.field] = originRow[idx2]
            }
          })
          footerRows.push(row)
        })
      }
      return [...this.tableData.data, ...footerRows]
    },
    exportParams () {
      const ret = []
      // 生成导出表头
      const { columns, data } = this.tableData
      const titleRow = columns.map(item => {
        return item.title
      })
      ret.push(titleRow)
      // 生成数据
      data.map(item => {
        const row = []
        columns.map(col => {
          if (col.formatter) {
            row.push(col.formatter({ row: item }))
          } else {
            row.push(item[col.field])
          }
        })
        ret.push(row)
      })
      // 增加总计行
      this.footerRow.map(item => {
        ret.push(item)
      })
      // 生成合并单元格规则
      const mergeList = []
      let start = 0
      let end = 0
      ret.map((item, index) => {
        if (index !== 0 && item[0] !== ret[index - 1][0]) {
          end = index - 1
          mergeList.push({ s: { r: start, c: 0 }, e: { r: end, c: 0 } })
          start = index
        }
        if (index === ret.length - 1) {
          end = index
          mergeList.push({ s: { r: start, c: 0 }, e: { r: end, c: this.groupCount - 1 } })
        }
      })
      return {
        data: ret,
        merges: mergeList,
      }
    },
  },
  methods: {
    getSortData (data, property, order) {
      const list = [...data]
      if (property && order) {
        list.sort((a, b) => {
          const aV = property === 'percent' ? parseFloat(a[property]) : a[property]
          const bV = property === 'percent' ? parseFloat(b[property]) : b[property]
          if (aV > bV) {
            return 1
          } else if (aV < bV) {
            return -1
          } else {
            return 0
          }
        })
        if (order === 'desc') {
          list.reverse()
        }
      }
      return list
    },
    getTagKey (key) {
      const ret = key.replace('user:', '')
      // 没有标签的资源，默认生成的
      // if (ret === 'cloud_default') {
      //   ret = this.$t('common_736')
      // }
      return ret
    },
    // 聚合groupCount=2数据到groupCount=1
    // params <Array> [{name: '1', data:[{date_info: '2021-07', stat_value: 1}, {date_info: '2021-08', stat_value: 2}]},{name: '1', data:[{date_info: '2021-07', stat_value: 1}, {date_info: '2021-08', stat_value: 2}]}]
    // return <Array> [{date_info: '2021-07', stat_value: 2}, {date_info: '2021-08', stat_value: 4}]
    groupStatValue (list) {
      const ret = []
      list[0].data.map(item => {
        const obj = {
          date_info: item.date_info,
          stat_value: 0,
        }
        list.map(level1 => {
          level1.data.map(level2 => {
            if (level2.date_info === item.date_info) {
              obj.stat_value += level2.stat_value
            }
          })
        })
        ret.push(obj)
      })
      return ret
    },
    getDate () {
      const T = time => this.$moment(time)
      const nowMonth = T(new Date()).month() + 1
      const selectMonth = T(this.month).month() + 1
      const selectDate = T(this.month).startOf('month').format('YYYY-MM-DD') + 'TZ'
      let endDate = T(this.month).endOf('month').format('YYYY-MM-DD') + 'TZ'
      if (nowMonth === selectMonth) {
        // 说明是在当前月份
        endDate = T(this.month).format('YYYY-MM-DD') + 'TZ'
      }
      return {
        start_date: selectDate,
        end_date: endDate,
        data_type: 'day',
      }
    },
    getNameI18n (name, type) {
      if (name === 'other') {
        return this.$t('bill.other')
      }
      if (type === 'resource_type') {
        return getBillResourceTypeLabel(name)
      }
      if (type === 'charge_type') {
        return i18n.te(`billingType.${name}`) ? i18n.t(`billingType.${name}`) : name
      }
      if (type === 'brand') {
        return BRAND_MAP[name] ? BRAND_MAP[name].label : name
      }
      if (type === 'account') {
        return name === 'OneStack' ? accountsFilterByOem({ data: { name } }).name || name : name
      }
      if (type === 'tag' && this.tagGroupParams && (this.tagGroupParams.tag_key || this.tagGroupParams.tag_key1)) {
        if (!name) {
          return i18n.t('bill.null_value')
        } else if (name === '___no_value__') {
          return i18n.t('common_736')
        }
      }
      if (type === 'project_tag' && this.projectTagGroupParams && (this.projectTagGroupParams.project_tag_key || this.projectTagGroupParams.project_tag_key1)) {
        if (!name) {
          return i18n.t('bill.null_value')
        } else if (name === '___no_value__') {
          return i18n.t('common_736')
        }
      }
      if (type === 'instance_tag' && this.instanceTagGroupParams && (this.instanceTagGroupParams.instance_tag_key || this.instanceTagGroupParams.instance_tag_key1)) {
        if (!name) {
          return i18n.t('bill.null_value')
        } else if (name === '___no_value__') {
          return i18n.t('common_736')
        }
      }
      return name
    },
    getSortDataBySum (dataList, valueKey) { // valueKey 可动态切换是展示应付金额还是二次定价金额
      const _dataList = R.clone(dataList)
      const { operation_num, service_period } = this.formData
      if (this.groupCount === 1) {
        for (let index = 0; index < _dataList.length; index++) {
          const item = _dataList[index]
          const stat_values = item.data.map(obj => {
            if (R.is(Number, operation_num) && R.is(Number, service_period)) {
              if (operation_num > 0 && service_period > 0) {
                obj.stat_value = obj[valueKey] / operation_num * service_period
              } else {
                obj.stat_value = obj[valueKey]
              }
            } else {
              obj.stat_value = obj[valueKey]
            }
            return obj.stat_value
          })
          const stat_value_sum = R.sum(stat_values)
          _dataList[index].stat_value_sum = stat_value_sum
        }
      } else if (this.groupCount === 2) {
        for (let index = 0; index < _dataList.length; index++) {
          const item = _dataList[index]
          const stat_values = item.data.map(obj => {
            let value = 0
            obj.data.map(l => {
              if (R.is(Number, operation_num) && R.is(Number, service_period)) {
                if (operation_num > 0 && service_period > 0) {
                  l.stat_value = l[valueKey] / operation_num * service_period
                } else {
                  l.stat_value = l[valueKey]
                }
              } else {
                l.stat_value = l[valueKey]
              }
              value += l.stat_value
            })
            return value
          })
          const stat_value_sum = R.sum(stat_values)
          _dataList[index].stat_value_sum = stat_value_sum
        }
      }
      _dataList.sort((a, b) => b.stat_value_sum - a.stat_value_sum)
      return _dataList
    },
    operationNumChangeHandle (v) {
      if (!R.is(Number, v) || v <= 0) {
        this.formData.operation_num = 1
      }
    },
    servicePeriodChangeHandle (v) {
      if (!R.is(Number, v) || v <= 0) {
        this.formData.service_period = 1
      }
    },
  },
}
